import React, { Component } from "react";

import { Layout, Login } from "../../components";
import { Container, Row, Col } from "reactstrap";
import { Register } from "..";
import HisLogo from "../../assets/images/his-hotels.png";
import "../../assets/css/custom2.css";
import Axios from "axios";
import { login } from "../../actions/authActions";
import { connect } from "react-redux";
import * as Env from "../../Env";

class TwoFactorAuth extends Component {
  constructor(props) {
    super(props);

    const { state } = props.location || {};
    let credentials = state && state.credentials ? state.credentials : {};
    let codeExpiresAt = state && state.codeExpiresAt ? state.codeExpiresAt : null;

    this.state = {
      code: Array(8).fill(""),
      errors: "",
      status: "",
      timer: 0,
      resendCooldown: 0,
      codeExpiresAt: codeExpiresAt,
      email: credentials.email || "",
      password: credentials.password || "",
      nextPath: credentials.nextPath || "/"
    };

    this.inputRefs = Array(8)
      .fill()
      .map(() => React.createRef());
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.startCodeExpiryCountdown();
    this.startResendCooldown();
  }

  startResendCooldown = () => {
    clearInterval(this.resendInterval);

    this.setState({ resendCooldown: 60 });

    this.resendInterval = setInterval(() => {
      this.setState(prevState => {
        if (prevState.resendCooldown <= 1) {
          clearInterval(this.resendInterval);
          return { resendCooldown: 0 };
        }
        return { resendCooldown: prevState.resendCooldown - 1 };
      });
    }, 1000);
  };

  startCodeExpiryCountdown = () => {
    clearInterval(this.countdownInterval);

    let { codeExpiresAt } = this.state;
    if (!codeExpiresAt) return;
    if (codeExpiresAt && codeExpiresAt.includes(".") && codeExpiresAt.endsWith("Z")) {
      codeExpiresAt = codeExpiresAt.replace(/\.(\d{3})\d{3}Z$/, ".$1Z");
    }

    const expiresAt = new Date(codeExpiresAt).getTime();

    this.countdownInterval = setInterval(() => {
      const now = new Date().getTime();
      const diff = expiresAt - now;

      if (diff <= 0) {
        clearInterval(this.countdownInterval);
        this.setState({ timer: 0 });
        return;
      }

      const seconds = Math.floor(diff / 1000);
      this.setState({ timer: seconds });
    }, 1000);
  };

  componentWillUnmount() {
    clearInterval(this.countdownInterval);
    clearInterval(this.resendInterval);
  }

  handleChange = (index, value) => {
    const newCode = [...this.state.code];
    newCode[index] = value.slice(0, 1);
    this.setState({ code: newCode }, () => {
      if (value && index < 7) {
        this.inputRefs[index + 1].current.focus();
      }
      if (newCode.every(char => char.length === 1)) {
        this.handleSubmit({ preventDefault: () => {} });
      }
    });
  };

  handlePaste = e => {
    const paste = e.clipboardData.getData("text").trim();
    if (paste.length === 8 && /^\d{8}$/.test(paste)) {
      const newCode = paste.split("");
      this.setState({ code: newCode }, () => {
        this.handleSubmit({ preventDefault: () => {} });
      });
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    const { code, email, password, nextPath } = this.state;
    const finalCode = code.join("");

    if (finalCode.length < 8) {
      this.setState({ errors: "Please enter the full 8-digit code." });
      return;
    }

    this.setState({ load_button: true });

    Axios.post(Env.url.api_url + "frontend/verify-code-twofa", {
      email: email,
      code: finalCode
    })
      .then(response => {
        if (response.status === 200) {
          return this.props.dispatch(login({ email, password, nextPath }));
        } else {
          throw new Error("Verification failed.");
        }
      })
      .catch(error => {
        const errorMessage =
          error.response.data.message || "Invalid verification code. Please check the code and try again";
        this.setState({
          errors: errorMessage,
          load_button: false
        });
      });
  };

  formatTime = () => {
    const minutes = Math.floor(this.state.timer / 60)
      .toString()
      .padStart(2, "0");
    const seconds = (this.state.timer % 60).toString().padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  render() {
    const { code, errors, status, timer, resendCooldown } = this.state;

    return (
      <section>
        <Container
          className="rcontainer d-flex justify-content-center align-items-center"
          style={{ minHeight: "100vh" }}
        >
          <div className="login-box text-center">
            <div className="login-logo mb-3">
              <img src={HisLogo} alt="Hoteripcom" style={{ maxWidth: "150px" }} />
            </div>

            <div className="two-factor-auth-box-body p-4 border rounded shadow-sm bg-white">
              <h3 className="mb-4">Two-factor Authentication</h3>

              <p className="mb-3">
                Your account is protected with two-factor authentication.
                <br />
                The verification code has been sent to your email. Please enter the code to continue.
              </p>

              {errors && <div className="alert alert-danger text-center">{errors}</div>}
              {status && <div className="alert alert-info text-center">{status}</div>}

              <form onSubmit={this.handleSubmit} className="mx-auto" style={{ maxWidth: "360px" }}>
                <div className="two-factor-code-inputs mb-3 d-flex justify-content-between">
                  {code.map((val, index) => (
                    <input
                      key={index}
                      type="text"
                      maxLength="1"
                      className="two-factor-code-input text-center"
                      required
                      autoComplete="off"
                      value={val}
                      onChange={e => this.handleChange(index, e.target.value)}
                      onPaste={this.handlePaste}
                      ref={this.inputRefs[index]}
                      style={{ width: "40px", height: "40px", fontSize: "24px" }}
                    />
                  ))}
                </div>
              </form>

              <p id="countdown" className="text-center text-muted mt-3" style={{ fontSize: "16px" }}>
                This code will expire in <span id="timer">{this.formatTime()}</span>
              </p>

              <p className="mt-3 text-muted text-center" style={{ fontSize: "14px" }}>
                <span
                  id="resendCodeLink"
                  className="text-success"
                  style={{
                    pointerEvents: resendCooldown === 0 ? "auto" : "none",
                    opacity: resendCooldown === 0 ? 1 : 0.5,
                    cursor: resendCooldown === 0 ? "pointer" : "not-allowed",
                    textDecoration: resendCooldown === 0 ? "underline" : "none"
                  }}
                  onClick={e => {
                    e.preventDefault();

                    if (resendCooldown === 0) {
                      console.log("Resending code and restarting timers...");

                      Axios.post(Env.url.api_url + "frontend/resend-code-twofa", {
                        email: this.state.email
                      })
                        .then(response => {
                          const newExpiresAtTimestamp = response.data.expiresAt;

                          if (newExpiresAtTimestamp) {
                            const newExpiresAt = new Date(newExpiresAtTimestamp).toISOString();
                            this.setState(
                              {
                                codeExpiresAt: newExpiresAt,
                                status: response.data.message || "Verification code resent. Please check your email.",
                                errors: ""
                              },
                              () => {
                                this.startCodeExpiryCountdown();
                              }
                            );
                          }

                          this.startResendCooldown();
                        })
                        .catch(error => {
                          console.error("Failed to resend code:", error);
                          this.setState({
                            errors: "Failed to resend verification code.",
                            status: ""
                          });
                        });
                    }
                  }}
                >
                  {resendCooldown > 0
                    ? `Please wait ${resendCooldown}s before requesting a new code.`
                    : "Click here to resend code"}
                </span>
              </p>
            </div>

            <div style={{ marginTop: "40px", textAlign: "center" }}>
              <p style={{ fontSize: "14px" }}>© HIS Hotels 2024. All rights reserved</p>
            </div>
          </div>
        </Container>
      </section>
    );
  }
}

const mapStateToProps = state => {
  return { dataAuth: state.authReducer };
};

export default connect(mapStateToProps)(TwoFactorAuth);
